<template>
  <div>
    <QueryBuilder :cube-api="cubeApi" :query="cubeQuery" ref="queryBuilder">
      <template #default="{ resultSet }">
        <component
          v-if="resultSet"
          :is="componentName"
          :result-set="resultSet"
          :filters="filters"
          :fullView="fullView"
          class="mx-auto"
          v-bind="$attrs"
          v-on="$listeners"
        />
      </template>
      <template #empty>
        <InsightsChartLoader />
      </template>
      <template #error>Error Loading chart</template>
    </QueryBuilder>
  </div>
</template>

<script>
import { QueryBuilder } from '@cubejs-client/vue'
import cube from '@cubejs-client/core'

export default {
  name: 'CubeQueryRenderer',
  inheritAttrs: false,
  components: {
    QueryBuilder
  },
  data () {
    return {
      cubeApi: cube(this.$msal.data.accessToken, { apiUrl: process.env.VUE_APP_CUBE_API_URL || 'http://localhost:4000' })
    }
  },
  props: {
    filters: {
      type: Array,
      required: true,
      default: () => []
    },
    dateRange: {
      type: Array,
      required: true,
      default: () => []
    },
    componentName: {
      type: String,
      required: true
    },
    defaultQuery: {
      type: Object,
      required: true
    },
    timeDimension: {
      type: String,
      required: true
    },
    fullView: {
      type: Boolean
    }
  },
  computed: {
    queryFilters () {
      if (!this.defaultQuery.filters) {
        return this.filters
      }

      const defaultQueryFilters = this.defaultQuery.filters
      const filters = this.filters.filter((f) => {
        return !defaultQueryFilters.some((df) => df.member === f.member)
      })

      const clonedFilters = [...defaultQueryFilters, ...filters]

      return clonedFilters.map(f => {
        return {
          member: f.member,
          operator: f.operator,
          values: f.values
        }
      })
    },
    queryTimeDimensions () {
      if (this.timeDimension && this.dateRange.length) {
        return [{
          dimension: this.timeDimension,
          dateRange: this.dateRange
        }]
      }

      return []
    },
    cubeQuery () {
      return {
        measures: this.defaultQuery.measures,
        dimensions: this.defaultQuery.dimensions,
        filters: this.queryFilters,
        timeDimensions: this.queryTimeDimensions
      }
    }
  }
}
</script>
